var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('PrimaryTitle',[_vm._t("title")],2),(_vm.$slots.subtitle)?_c('SecondaryTitle',{staticClass:"subtitle"},[_vm._t("subtitle")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }